// JavaScript source code
import React from 'react'
import '../styles/aboutus-styles.css';
export default function AboutUsMidContent() {



    return (


        //<section className="team-section about-page home-20 pt_70 pb_85" style={{ textAlign: 'left' }}>
        //           <div className="auto-container">
        //               <div className="row">
        //                   <div className="col-md-5">
        //                       <div className="sec-title mb_60">
        //                           <span className="sub-title mb_14">Our Experts</span>
        //                           <h3>Our team consists of seasoned experts dedicated to providing exceptional personal and business financial guidance, comprehensive business consultation, and ongoing support.</h3>
        //                       </div>
        //                   </div>
        //                   <div className="col-md-7">
        //                       <div className="inner-container">
        //                           <div className="row clearfix">

        //                               <div class="col-lg-6 col-md-6 col-sm-12 team-block">
        //                                   <div className="team-block-three wow fadeInUp animated" data-wow-delay="200ms">
        //                                       <div className="inner-box">
        //                                           <div className="image-box">
        //                                               <figure className="image"><a href="javascript:void(0)"><img src="assets/images/team/team-11.jpg" alt="" /></a></figure>
        //                                               <ul className="social-links">
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-facebook-f"></i></a></li>
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-twitter"></i></a></li>
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-linkedin-in"></i></a></li>
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-instagram"></i></a></li>
        //                                               </ul>
        //                                           </div>
        //                                           <div className="lower-content">
        //                                               <h3><a href="#">Rodney Rutty</a></h3>
        //                                               <span className="designation">CEO</span>
        //                                               <span class="designation">NMLS# 1058549</span>
        //                                           </div>
        //                                       </div>
        //                                   </div>
        //                               </div>
        //                               <div class="col-lg-6 col-md-6 col-sm-12 team-block">
        //                                   <div className="team-block-three wow fadeInUp animated" data-wow-delay="400ms">
        //                                       <div className="inner-box">
        //                                           <div className="image-box">
        //                                               <figure className="image"><a href="javascript:void(0)"><img src="assets/images/team/team-10.jpg" alt="" /></a></figure>
        //                                               <ul className="social-links">
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-facebook-f"></i></a></li>
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-twitter"></i></a></li>
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-linkedin-in"></i></a></li>
        //                                                   <li><a href="javascript:void(0)"><i className="fab fa-instagram"></i></a></li>
        //                                               </ul>
        //                                           </div>
        //                                           <div className="lower-content">
        //                                               <h3><a href="#">Viviana Augustin</a></h3>
        //                                               <span className="designation">CFO</span>
        //                                           </div>
        //                                       </div>
        //                                   </div>
        //                               </div>
        //                           </div>
        //                       </div>
        //                   </div>
        //               </div>
        //               <div className="row mt-4 align-items-center partner-sec">
        //                   <div className="col-12 col-lg-8 order-md-2 order-lg-1 ">
        //                       <div className="sec-title mb_60">
        //                           <span className="sub-title mb_14">Our Technology Services</span>
        //                           <h3>Ravline Corp partnered with Hansai Technosoft LLC to deliver top-notch IT services and solutions through their successful BOT (Build-Operate-Transfer) business model. As part of this collaboration, we are proud to bundle Hansai�s exceptional BOT services with our offerings, enhancing our capabilities and driving innovation. Together with Hansai Technosoft LLC, we look forward to providing unparalleled value to our clients through cutting-edge technology solutions and seamless integration.
        //                           </h3>
        //                       </div>
        //                   </div>
        //                   <div className="col-md-12 col-lg-4 order-lg-2 order-md-1">
        //                       <div className="team-block-three pt-3">
        //                           <div className="inner-box ps-0 ps-lg-4">
        //                               <div className="image-box">
        //                                   <figure className="image"><a href="https://hansaitechnosoft.com/" target="_blank"><img src="assets/images/hansai-tech-logo.jpg" alt="" /></a></figure>
        //                               </div>
        //                           </div>
        //                       </div>
        //                   </div>
        //               </div>
        //           </div>
        //       </section>



        <section class="team-section1 professional-section1 pt-5 pb-5">
            <div class="container1">
                <div class="row align-items-center">

                    <div class="col-lg-5">
                        <div class="section-header1 mb-4">
                            <h4 class="sub-heading1"> Meet Our Professionals</h4>
                            <p class="">Our dedicated team of seasoned professionals is unwavering in its commitment to delivering exceptional financial guidance, strategic business consultations, and unmatched support tailored to help you achieve and exceed your personal aspirations and professional objectives with precision and excellence.</p>
                        </div>
                    </div>


                    <div class="col-lg-7">
                        <div class="team-grid1">
                            <div class="team-card1" data-aos="fade-up" data-aos-delay="100">
                                <div class="image-wrapper1">
                                    <img src="assets/images/team/team-25.jpg" alt="Rodney Rutty" class="team-image1"></img>
                                </div>
                                <div class="content-wrapper1">
                                    <h3 class="team-name1">Rodney Rutty</h3>
                                    <p class="team-role1">CFO</p>
                                    <p class="team-role1">NMLS# 1058549</p>

                                    <div class="social-links1">
                                        <a href="#" class="social-link1"><i class="fab fa-facebook-f"></i></a>
                                        <a href="#" class="social-link1"><i class="fab fa-twitter"></i></a>
                                        <a href="#" class="social-link1"><i class="fab fa-linkedin-in"></i></a>
                                        <a href="#" class="social-link1"><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="team-card1" data-aos="fade-up" data-aos-delay="200">
                                <div class="image-wrapper1">
                                    <img src="assets/images/VivianaAugustin.webp" alt="Viviana Augustin" class="team-image1"></img>
                                </div>
                                <div class="content-wrapper1">
                                    <h3 class="team-name1">Viviana Augustin</h3>
                                    <p class="team-role1">CEO</p>
                                    <div class="social-links1">
                                        <a href="#" class="social-link1"><i class="fab fa-facebook-f"></i></a>
                                        <a href="#" class="social-link1"><i class="fab fa-twitter"></i></a>
                                        <a href="#" class="social-link1"><i class="fab fa-linkedin-in"></i></a>
                                        <a href="#" class="social-link1"><i class="fab fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5 align-items-center">

                    <div class="col-lg-8">
                        <div class="section-header1">
                            <h4 class="sub-heading1"> Technology Partnership</h4>
                            <h2 class="main-heading1">Innovating Together with Hansai Technosoft LLC</h2>
                            <p class="">Ravline Corp partnered with Hansai Technosoft LLC to deliver top-notch IT services and solutions through their successful BOT (Build-Operate-Transfer) business model. As part of this collaboration, we are proud to bundle Hansai exceptional BOT services with our offerings, enhancing our capabilities and driving innovation. Together with Hansai Technosoft LLC, we look forward to providing unparalleled value to our clients through cutting-edge technology solutions and seamless integration.</p>
                        </div>
                    </div>

                    <div class="col-lg-4 text-center">
                        <div class="partner-logo1" data-aos="zoom-in">
                            <a href="https://hansaitechnosoft.com/" target="_blank">
                                <img src="assets/images/HST-LOGO.png" alt="Hansai Technosoft LLC" class="logo-image1"></img>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>



    );
}